export default __webpack_public_path__ + "static/media/img-0673-albania-premium-face.9462ff9c.png";